import { GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200 } from '@fukuri-admins/apis/client/gen/model';
import { fetchWrapper } from '@fukuri-admins/apis/fetchWrapper';
import { REQUEST_API_URL } from '@fukuri-admins/constants/common';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  stressAssessmentId: number;
  filter: 'completed' | 'pending' | 'interview_requested';
  page: string;
};

const fetcher = async (
  threeLetterCode: string,
  stressAssessmentId: number,
  filter: string,
  page: string
) => {
  const url = `${REQUEST_API_URL}/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/results?f=${filter}&page=${page}`;
  const response = await fetchWrapper(url, { method: 'GET' });

  if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);

  const data = await response.json();
  const headers = Object.fromEntries(response.headers.entries());

  return { data, headers };
};

export const useGetStressAssessmentUserReportList = (threeLetterCode: string, args: Args) => {
  const { stressAssessmentId, filter, page } = args;
  const endpoint = `${REQUEST_API_URL}/${threeLetterCode}/client_admins/stress_assessments/${stressAssessmentId}/results?f=${filter}&page=${page}`;
  const { data: result } = useFetch<{
    data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResults200;
    headers: Record<string, string>;
  }>(endpoint, () => fetcher(threeLetterCode, stressAssessmentId, filter, page));

  return {
    data: result?.data,
    headers: result?.headers,
  };
};
